import React, { useEffect, useState } from 'react'
import SubmitButton from '../../components/controls/SubmitButton/SubmitButton'

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from './EditSubsidiary.module.css';
import { LegalEntityParentCompanyServiceApi, LegalEntitySubsidiaryServicesApi } from '../../service';
import Loading from '../../components/Loading/Loading';
import GenericModal from '../../UI/GenericModal';
import { useHistory } from 'react-router-dom';
import DropdownSelect from '../../components/controls/DropdownSelect/DropdownSelect';
import { isSuperuserValue } from '../../access/access';

let urlSearchParams = new URLSearchParams(window.location.search);
let params = Object.fromEntries(urlSearchParams.entries());
let queryStringSubsidiaryId = params["subsidiaryId"];

const EditSubsidiary = () => {
  const [allParentCompanies, setAllParentCompanies] = useState();
  const [newSubsidiaryName, setNewSubsidiaryName] = useState("");
  const [parentCompanyId, setParentCompanyId] = useState(0);
  const [authorityCode, setAuthorityCode] = useState("");
  const [isActiveSubsidiary, setIsActiveSubsidiary] = useState(true);
  
  const [subsidiaryId, setSubsidiaryId] = useState();
  const [isLoading, setIsLoading] = useState();
  const [error, setError] = useState();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();
  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    let mounted = true;
    setIsLoading(true);

    urlSearchParams = new URLSearchParams(window.location.search);
    params = Object.fromEntries(urlSearchParams.entries());
    queryStringSubsidiaryId = params["subsidiaryId"];
    console.log("queryStringSubsidiaryId: ", queryStringSubsidiaryId);
    setSubsidiaryId(queryStringSubsidiaryId);

    const subsidiaryServiceApi = new LegalEntitySubsidiaryServicesApi();
    subsidiaryServiceApi.getLegalEntitySubsidiaryById(queryStringSubsidiaryId, (error, subsidiaryData) => {
      if (mounted) {
        if (!error) {
          console.log("API subsidiary data: ", subsidiaryData);
          setNewSubsidiaryName(subsidiaryData.name);
          setParentCompanyId(subsidiaryData.legalEntityParentCompany ? subsidiaryData.legalEntityParentCompany.id : 1);
          setAuthorityCode(subsidiaryData.authorityCode);
          setIsActiveSubsidiary(subsidiaryData.active);
          const parentCompanyServices = new LegalEntityParentCompanyServiceApi();
          parentCompanyServices.getAllLegalEntityParentCompany(true, (error, parentCompaniesData) => {
          console.log("API all parent companies: ", parentCompaniesData);
          if (mounted) {
            if (!error) {
              setAllParentCompanies(parentCompaniesData.sort( (a,b) => a.id > b.id ? 1 : -1));
              setIsLoading(false);
            } else {
              setError(() => {
                throw new Error ("");
                // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
              })
            }
          }
        })
      } else {
        setError(() => {
          throw new Error ("");
          // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
        })
      }
    }
  });
    
    return (() => {
      mounted = false;
    })
  },[]);
  
  const subsidiaryNameHandler = (value) => {
    setNewSubsidiaryName(value);
  }
  
  const authorityCodeHandler = (value) => {
    let val = value.replace(/[^A-Za-z0-9]/ig, '')
    val = val.toUpperCase();
    setAuthorityCode(val);
  }
  
  const parentCompanyChangeHandler = (parComId) => {
    setParentCompanyId(parComId)
    console.log(allParentCompanies.filter(el => el.id === parComId))
  }

  const updateActiveSubsidiaryValue = (value) => {
    console.log("Active value: ", value);
    setIsActiveSubsidiary(value);
  }

  const submitFormHandler = () => {
    console.log("Submit function")
    
    if (validValues()) {
      setIsLoading(true);
      const requestBody = {
        id: subsidiaryId,
        name: newSubsidiaryName,
        active: isActiveSubsidiary,
        authorityCode: authorityCode,
        legalEntityParentCompanyId: parentCompanyId,
      }
      
      console.log("requestBody: ", requestBody);
      const subsidiaryServicesApi = new LegalEntitySubsidiaryServicesApi();
      subsidiaryServicesApi.updateLegalEntitySubsidiaryById(requestBody, subsidiaryId, (error, data) => {
        if (!error) {
          setIsLoading(false);
          modalDataHandler("", `The subsidiary "${newSubsidiaryName}" was updated`, 'notification', () => history.push("/subsidiary-monitor"))  
        } else {
          setIsLoading(false);
          modalDataHandler(`Error ${(error.response ? error.response.statusCode : "")}`, `Error ocurred. The subsidiary could not be created!`, 'error', modalCloseHandler)  
        }
      })
    } else {
       modalDataHandler("", `A name must be typed for the subsidiary.`, 'notification', modalCloseHandler)
    }
  }

  const validValues = () => {
    if (newSubsidiaryName.length === 0 || authorityCode.length === 0 || subsidiaryId === 0) {
      return false;
    } else {
      return true;
    }
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  const requestBody = {
    name: newSubsidiaryName,
    active: isActiveSubsidiary,
    authorityCode: authorityCode,
    legalEntitySubsidiaryId: subsidiaryId,
  }

  console.log("requestBody: ", requestBody);
  console.log("allParentCompanies: ", allParentCompanies);
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        modalDataHandler(
          "Update subsidiary",
          "Update subsidiary?",
          "confirmation",
          submitFormHandler
        );
      }}
    >
      <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
      <div className="d-flex justify-content-between mt-2">
        <div className="d-flex flex-column">
          <label className="fw-bold mb-1 ms-1">
            Subsidiary
          </label>
          <input
            className={styles.textInput}
            type="text"
            value={newSubsidiaryName}
            onChange={(e) => {
              subsidiaryNameHandler(e.target.value);
            }}
            placeholder="Type subsidiary name"
          />
        </div>
        <div className="d-flex flex-column">
          <label className="fw-bold mb-1 ms-1">
            Authority Code
          </label>
          <input
            className={`${styles.textInput}`}
            type="text"
            // pattern="[A-Z0-9-]+"
            maxLength="9"
            size="14"
            value={authorityCode}
            onChange={(e) => {
              authorityCodeHandler(e.target.value);
            }}
            placeholder="Type authority code"
          />
        </div>
        <div className="d-flex flex-column align-items-center">
          <label htmlFor="active" className="mb-1 fw-bold">
            Active
          </label>
          <input
            type="checkbox"
            id="active"
            className={styles.activeCheckbox}
            name="activeValue"
            checked={isActiveSubsidiary}
            onChange={(e) => {
              updateActiveSubsidiaryValue(e.target.checked);
            }}
          />
        </div>
        <div>
          <img src={nexiLogo} className={`${styles.logo}`} alt="nexi-group" />
        </div>
      </div>
      <div className="hr position-relative mt-4"></div>
      {isLoading && <Loading height={"82px"} />}
      {!isLoading && (
        <div className="d-flex justify-content-between mb-4">
          <div className="d-flex">
            <div className="me-5">
              <label className="fw-bold mb-1 mt-4 ms-1">Parent Company</label>
              {allParentCompanies && (
                <DropdownSelect
                  data={allParentCompanies}
                  name={"parentCompanies"}
                  emptyListMessage={"Select a Parent Company"}
                  defaultValue={parentCompanyId}
                  onChange={parentCompanyChangeHandler}
                  //  onChange={event => controlFunctionChange(event)}
                ></DropdownSelect>
              )}
            </div>
          </div>
          <div className="d-flex align-items-end">
            <SubmitButton
              type="submit"
              disabled={!validValues()}
              class={`${styles.submitButton} mt-3 mb-1 me-3 float-end`}
            >
              Update
            </SubmitButton>
          </div>
        </div>
      )}
    </form>
  );
}

export default EditSubsidiary;